import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const OverallSalesReportPage = lazy(() => import('./pages/OverallSalesReportPage'));
const PublisherSalesReportPage = lazy(() => import('./pages/PublisherSalesReportPage'));

const salesReportsRoutes: RouteObject[] = [
  {
    path: 'sales-reports/overall',
    element: <OverallSalesReportPage />,
  },
  {
    path: 'sales-reports/publisher',
    element: <PublisherSalesReportPage />,
  },
];

export default salesReportsRoutes;
